import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import firebase from "firebase/app";
import { FaPencilAlt } from "react-icons/fa";
import styles from "./mythMaker.module.css";
import Page from "../page/Page";
import { app } from "../../helpers/myFirebase";
import NewMythEditor from "./newMythEditor/NewMythEditor";
import Login from "../../components/login/Login";
import MythSummary from "./mythSummary/MythSummary";
import DeleteConfirmModal from "../../components/deleteConfirmModal/DeleteConfirmModal";

const db = app.firestore();
const auth = firebase.auth();
const storage = app.storage();

const defaultMythData = {
  title: "",
  excerpt: "",
  location: {
    lat: 54.19581358242665,
    lng: -3.096303451814875,
  },
};

export default function MythMaker({ mythData }) {
  const [currMyth, setCurrMyth] = useState(defaultMythData);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const history = useHistory();
  const { id } = useParams();
  const [user] = useAuthState(auth);

  useEffect(() => {
    if (!id || !mythData || id === "new") return;
    const m = mythData.find((m) => m.id === id);

    if (m) {
      setCurrMyth(m);
    } else {
      history.push("/maker");
    }
  }, [id, mythData, history]);

  const onMySummaryClose = () => {
    history.push(`/maker`);
  };

  const addMyth = () => {
    db.collection("myths")
      .add({
        title: currMyth.title,
        excerpt: currMyth.excerpt,
        location: { lat: currMyth.location.lat, lng: currMyth.location.lng },
      })
      .then((docRef) => {
        console.log("Document written with ID: ", docRef.id);
        history.push(`/maker/${docRef.id}`);
      })
      .catch((error) => {
        console.error("Error adding document: ", error);
      });
  };

  const onUpdate = () => {
    if (!currMyth) return;

    db.collection("myths")
      .doc(currMyth.id)
      .set(
        {
          title: currMyth.title,
          excerpt: currMyth.excerpt,
          location: { lat: currMyth.location.lat, lng: currMyth.location.lng },
        },
        { merge: true }
      );
  };

  const onDeleteMyth = () => setShowDeleteConfirm(true);
  const onDeleteMythCancel = () => setShowDeleteConfirm(false);

  const onDeleteMythConfirm = () => deleteMyth();

  const deleteMyth = async () => {
    let fileRef;
    var storageRef = storage.ref();

    const placePhoto =
      currMyth.placePhoto && currMyth.placePhoto.name
        ? currMyth.placePhoto.name
        : null;

    const comicPhoto =
      currMyth.comicPhoto && currMyth.comicPhoto.name
        ? currMyth.comicPhoto.name
        : null;

    const audio =
      currMyth.audio && currMyth.audio.name ? currMyth.audio.name : null;

    try {
      if (placePhoto) {
        fileRef = storageRef.child(placePhoto);
        await fileRef.delete();
      }
      if (comicPhoto) {
        fileRef = storageRef.child(comicPhoto);
        await fileRef.delete();
      }
      if (audio) {
        fileRef = storageRef.child(audio);
        await fileRef.delete();
      }

      await db.collection("myths").doc(currMyth.id).delete();
    } catch (error) {
      alert(`There was an error: ${error}`);
    }
  };

  const isEditingMyth = id && id !== "new";
  const isNewMyth = id && id === "new";

  return (
    <Page>
      <div className={styles.mythMaker}>
        {showDeleteConfirm && (
          <DeleteConfirmModal
            onDeleteMythConfirm={onDeleteMythConfirm}
            onDeleteMythCancel={onDeleteMythCancel}
            currMyth={currMyth}
          />
        )}

        <header>
          <h1>
            <FaPencilAlt /> Myth Maker
          </h1>

          <p>
            Edit the Myths or add new ones. Schools - you will be given log in
            details to set up and manage your myths.{" "}
            <a href="https://artfly.io/chris-dennett/">Get in touch</a> if you
            want to find out more about this project.
          </p>
        </header>

        <Login />

        {user && (
          <div>
            {!isEditingMyth && !isNewMyth && (
              <div className={styles.options}>
                {/* EDIT MYTH */}
                {mythData && (
                  <>
                    <h2>Edit a myth:</h2>
                    <div className={styles.editMythsSection}>
                      {mythData.map((m) => (
                        <Link
                          key={m.id}
                          to={`/maker/${m.id}`}
                          className={`funButton ${styles.editMythButt}`}
                        >
                          {m.title}
                        </Link>
                      ))}
                    </div>
                  </>
                )}

                {/* ADD NEW MYTH */}
                <div className={styles.addMythSection}>
                  <h2>Or add a new one:</h2>
                  <Link className="funButton" to="/maker/new">
                    Create Myth
                  </Link>
                </div>
              </div>
            )}

            {/* NEW MYTH */}
            {isNewMyth && (
              <div className={styles.formSection}>
                <NewMythEditor currMyth={currMyth} setCurrMyth={setCurrMyth} />

                <button
                  className={`funButton ${styles.saveNewMythButt}`}
                  onClick={addMyth}
                >
                  Save
                </button>

                <Link className={`funButton cancel`} to="/maker">
                  Cancel
                </Link>
              </div>
            )}

            {/* EDIT MYTH */}
            {isEditingMyth && (
              <>
                <MythSummary
                  myth={currMyth}
                  setCurrMyth={setCurrMyth}
                  onUpdate={onUpdate}
                  onClose={onMySummaryClose}
                />
                <div className={styles.finishEditingSection}>
                  <Link className="funButton" to="/maker">
                    Finish Editing
                  </Link>

                  <button
                    className={`funButton cancel ${styles.deleteButt}`}
                    onClick={onDeleteMyth}
                  >
                    Delete Myth
                  </button>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </Page>
  );
}
